const disease_clingen = ["phenylketonuria",
    "PTEN hamartoma tumor syndrome",
    "Usher syndrome",
    "nonsyndromic genetic deafness",
    "hearing loss",
    "Pendred syndrome",
    "hypertrophic cardiomyopathy",
    "dilated cardiomyopathy",
    "cardiomyopathy",
    "Ebstein anomaly",
    "restrictive cardiomyopathy",
    "RASopathy",
    "Noonan syndrome",
    "Noonan syndrome-like disorder with loose anagen hair 1",
    "Noonan syndrome with multiple lentigines",
    "cardiofaciocutaneous syndrome",
    "Costello syndrome",
    "CDH1-related diffuse gastric and lobular breast cancer",
    "hereditary thrombocytopenia and hematologic cancer predisposition syndrome",
    "hereditary thrombocytopenia with normal platelets-hematological cancer predisposition syndrome",
    "sensorineural hearing loss disorder",
    "inherited retinal dystrophy",
    "glycogen storage disease II",
    "Li-Fraumeni syndrome",
    "Usher syndrome type 1",
    "Glanzmann's thrombasthenia",
    "Glanzmann thrombasthenia",
    "malignant hyperthermia, susceptibility to, 1",
    "Pitt-Hopkins syndrome",
    "Christianson syndrome",
    "Rett syndrome",
    "FOXG1 disorder",
    "CDKL5 disorder",
    "Angelman syndrome",
    "pyruvate dehydrogenase deficiency",
    "mitochondrial disease",
    "ethylmalonic encephalopathy",
    "malignant hyperthermia of anesthesia",
    "MYH7-related late-onset scapuloperoneal muscular dystrophy",
    "Li-Fraumeni syndrome 1",
    "hypercholesterolemia, familial",
    "overgrowth syndrome and/or cerebral malformations due to abnormalities in MTOR pathway genes",
    "monogenic diabetes",
    "juvenile open angle glaucoma",
    "primary open angle glaucoma",
    "very long chain acyl-CoA dehydrogenase deficiency",
    "hereditary breast cancer",
    "hereditary thrombocytopenia and hematological cancer predisposition syndrome associated with RUNX1",
    "DICER1-related tumor predisposition",
    "dicer1 syndrome",
    "Usher syndrome type 1B",
    "autosomal recessive nonsyndromic deafness 9",
    "AGAT deficiency",
    "guanidinoacetate methyltransferase deficiency",
    "creatine transporter deficiency",
    "Marfan syndrome",
    "familial adenomatous polyposis 1",
    "maturity-onset diabetes of the young type 2",
    "antithrombin III deficiency",
    "BRCA1-related cancer predisposition",
    "BRCA2-related cancer predisposition",
    "RPE65-related recessive retinopathy",
    "adenosine deaminase deficiency",
    "severe combined immunodeficiency, autosomal recessive, T cell-negative, B cell-positive, NK cell-positive",
    "T-B+ severe combined immunodeficiency due to gamma chain deficiency",
    "severe combined immunodeficiency due to DCLRE1C deficiency",
    "recombinase activating gene 1 deficiency",
    "recombinase activating gene 2 deficiency",
    "T-B+ severe combined immunodeficiency due to JAK3 deficiency",
    "telangiectasia, hereditary hemorrhagic, type 1",
    "telangiectasia, hereditary hemorrhagic, type 2",
    "hereditary diffuse gastric adenocarcinoma",
    "pulmonary arterial hypertension",
    "developmental and epileptic encephalopathy",
    "complex neurodevelopmental disorder",
    "Dravet syndrome",
    "hemophilia B",
    "hemophilia A",
    "von Hippel-Lindau disease",
    "T-cell immunodeficiency, congenital alopecia, and nail dystrophy",
    "von Willebrand disease type 2B",
    "von Willebrand disease type 2A",
    "hereditary von Willebrand disease",
    "von Willebrand disease type 2N",
    "von Willebrand disease type 2M",
    "centronuclear myopathy",
    "X-linked centronuclear myopathy",
    "nemaline myopathy",
    "RYR1-related myopathy",
    "Lynch syndrome 1",
    "Lynch syndrome",
    "colorectal cancer, hereditary nonpolyposis, type 2",
    "colorectal cancer, hereditary nonpolyposis, type 4",
    "generalized epilepsy with febrile seizures plus",
    "familial hemiplegic migraine",
    "mucopolysaccharidosis type 1",
    "alpha-actinopathy",
    "von Willebrand disease 2"
];

export default disease_clingen;